import { render, staticRenderFns } from "./WaitingForConfirm.vue?vue&type=template&id=35813467"
import script from "./WaitingForConfirm.vue?vue&type=script&lang=js"
export * from "./WaitingForConfirm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports